import classes from './Icon.module.css';
import React from 'react';
import mapSVG from "./svgs/map.svg";
import digitalCuratorshipSVG from "./svgs/digitalCuratorship.svg";
import chatSVG from "./svgs/chat.svg";
import userSVG from "./svgs/user.svg";
import backSVG from "./svgs/back.svg";
import locationSVG from "./svgs/location.svg";
import albertSVG from "./svgs/b-albert.svg";
import championshipsSVG from "./svgs/b-championships.svg";
import chatAiSVG from "./svgs/b-chatAi.svg";
import curatorshipSVG from "./svgs/b-curatorship.svg";
import gamesSVG from "./svgs/b-games.svg";
import magicSchoolSVG from "./svgs/b-magicSchool.svg";
import profileSVG from "./svgs/profile.svg";
import closeSVG from "./svgs/close.svg";
import eyeSVG from "./svgs/eye.svg";
import likeSVG from "./svgs/like.svg";
import accessibilitySVG from "./svgs/accessibility.svg";
import settingsSVG from "./svgs/settingsSVG.svg";
import refresh from "./svgs/refresh.svg";
import arrowSvg from "./svgs/arrow.svg";
import Tooltip from '../tooltip/Tooltip';
import checksvg from "./svgs/check.svg";
import filterSvg from "./svgs/filter.svg"


const iconComponents = {
    map: mapSVG,
    chat: chatSVG,
    digitalCuratorship: digitalCuratorshipSVG,
    user: userSVG,
    back: backSVG,
    location: locationSVG,
    albert: albertSVG,
    championships: championshipsSVG,
    chatAi: chatAiSVG,
    curatorship: curatorshipSVG,
    games: gamesSVG,
    magicSchool: magicSchoolSVG,
    profile: profileSVG,
    close: closeSVG,
    eye: eyeSVG,
    like: likeSVG,
    accessibility: accessibilitySVG,
    settings: settingsSVG,
    refresh: refresh,
    arrow: arrowSvg,
    check: checksvg,
    filter: filterSvg
};

const Icon = ({ color, name, size = "32px", onClick, className, tooltip }) => {

    const IconComponent = iconComponents[name];
    if (tooltip)
        return <Tooltip text={tooltip} showTooltip={true}>
            <div
                className={`${classes.Icon} ${className} `}
                onClick={onClick && onClick}
                dangerouslySetInnerHTML={{ __html: IconComponent }} style={{ color: color && color, stroke: color && color, width: size, height: size }}>
            </div>
        </Tooltip>
    return <div
        className={`${classes.Icon} ${className} `}
        onClick={onClick && onClick}
        dangerouslySetInnerHTML={{ __html: IconComponent }} style={{ color: color && color, stroke: color && color, width: size, height: size }}>
    </div>
}
export default Icon;


